export enum OperatorTypeIdEnum {
  Text = 1,
  Number = 2,
  Select = 3,
}

export enum OperatorTypeDisplayIdEnum {
  TextOrNumber = 0,
  Select = 3,
}
